import { render, staticRenderFns } from "./Conclusao.vue?vue&type=template&id=851a463a"
import script from "./Conclusao.vue?vue&type=script&lang=js"
export * from "./Conclusao.vue?vue&type=script&lang=js"
import style0 from "./Conclusao.vue?vue&type=style&index=0&id=851a463a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports